import React, { useState, useEffect } from "react";
import DashboardMenu from "../../commonComponents/DashboardMenu";
import DataTable from "react-data-table-component";
import DataTableExtensions from "react-data-table-component-extensions";
import "react-data-table-component-extensions/dist/index.css";
import { Button } from "@mui/material";
import Popover from "@mui/material/Popover";
import Typography from "@mui/material/Typography";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import CheckIcon from "@mui/icons-material/Check";
import CancelIcon from "@mui/icons-material/Cancel";
import useStyles from "../DashboardAuction/dashAuction.style";
import sellerListAPI from "../../../api/adminAPI/sellerListAPI";
import AuctionView from "../DashboardAuction/AuctionView";
import BidlogFirst from "../DashboardAuction/BidlogFirst";
import BidlogSecond from "../DashboardAuction/BidogSecond";
import DashBuyerDetail from "../DashboardAuction/BidlogFirst/DashBuyerDetail";
import DashEventDetail from "../DashboardAuction/BidlogFirst/DashEventDetail";
import BuyerBidLog from "../DashboardAuction/BidlogFirst/BuyerBidLog";
import EditEvent from "../DashboardAuction/EditDashEvent/EditEvent";
import AuctionTable from "../DashboardAuction/AuctionTable";
import EditTabEvent from "../DashboardAuction/EditDashEvent/EditTabEvent";
import AuctionViewFirst from "../DashboardAuction/BidlogFirst/AuctionViewFirst";
import AuctionSummary from "../DashboardAuction/BidlogFirst/AuctionSummary";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import sellerDeleteAPI from "../../../api/adminAPI/sellerDeleteAPI";
import sellerStatusUpdateAPI from "../../../api/adminAPI/sellerUpdateStatusAPI";
import sellerUpdateRightsAPI from "../../../api/adminAPI/sellerUpdateRightsAPI";
import getCountries from "../../../api/getContriesAPI";
import getStateAPI from "../../../api/getStateAPI";
import { isEmpty, omit } from "lodash";
import { getUserData } from "../../../common";
import getSellerDetails from "../../../api/adminAPI/getSellerDetails";
import updateSellerAPI from "../../../api/adminAPI/updateSellerAPI";
import { Navigate } from "react-router-dom";

import lodash from "lodash";
import { FaRegFileExcel } from "react-icons/fa";
import * as XLSX from "xlsx";
import SellerProfileModal from "./SellerProfileModal";

function DashSeller() {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [changeView, SetChangeView] = useState(false);
  const [eventId, SetEventId] = useState("");
  const [buyerId, SetBuyerId] = useState("");
  const [status, SetStatus] = useState("");
  const [buyerEventId, SetBuyerEventId] = useState("");
  const [buyerEventItemId, SetBuyerEvenItemtId] = useState("");
  const [eventItemId, SetEvenItemtId] = useState("");
  const [auctionRights, setAuctionRights] = useState("");
  const [countriesList, updateCountriesList] = useState({
    apiState: "loading",
    list: [],
  });

  const [stateList, updateStateList] = useState({
    apiState: "loading",
    list: [],
  });

  const [tableSellers, setTableSellers] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const sellerId = buyerId;

  useEffect(() => {
    countryList();
    stateData();
  }, []);

  useEffect(() => {
    sellerList();
  }, [eventId]);

  useEffect(() => {
    if (sellerId) {
      getProfileData(sellerId);
    }
  }, [sellerId]);

  const stateData = async (countryId) => {
    try {
      const { data } = await getStateAPI(countryId);
      if (data) {
        updateStateList({ apiState: "success", list: data });
      } else {
        throw new Error(data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const countryList = async () => {
    try {
      const { data } = await getCountries();
      if (data) {
        updateCountriesList({ apiState: "success", list: data });
      } else {
        throw new Error(data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const sellerList = async () => {
    try {
      const { data } = await sellerListAPI();
      if (data) {
        let id = 1;
        const sellersData = data.map((list) => {
          return {
            id: id++,
            companyName: list.companyName,
            businessType: list.businessType,
            title: list.title,
            userName: `${list.firstName} ${list.lastName}`,
            email: list.email,
            contactNumber: list.contactNumber,
            userId: list.userId,
            alternateContactNumber: list.alternateContactNumber,
            totalEventBuyers: list.totalEventBuyers,
            totalEventItems: list.totalEventItems,
            totalEvents: list.totalEvents,
            totalParticipants: list.totalParticipants,
            status: list.status,
            auctionStatus: list.auctionStatus,
            location: `${list.country} ${list.state}`,
          };
        });
        setTableSellers(sellersData);
      } else {
        throw new Error(data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleClick = (event, userId, status, auctionStatus) => {
    SetBuyerId(userId);
    setSellerRightsId(userId);
    SetStatus(status);
    setAuctionRights(auctionStatus);
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
    SetBuyerId("");
    SetStatus("");
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  const columns = [
    {
      name: "Sr No",
      selector: (data) => data.id,
      cell: (data) => String(data.id),
      width: "100px",
      sortable: true,
    },
    {
      name: "Title",
      selector: (data) => data.title,
      cell: (data) => String(data.title),
      sortable: true,
    },
    {
      name: "Seller name",
      selector: (data) => data.userName,
      cell: (data) => String(data.userName),
      sortable: true,
      width: "150px",
    },
    {
      name: "Company",
      selector: (data) => data.companyName,
      cell: (data) => String(data.companyName),
      sortable: true,
      width: "130px",
    },
    {
      name: "Mobile number",
      selector: (data) => data.contactNumber,
      cell: (data) => String(data.contactNumber),
      sortable: true,
      width: "140px",
    },
    {
      name: "Alt. mobile Number",
      selector: (data) => data.alternateContactNumber || "",
      cell: (data) => String(data.alternateContactNumber || ""),
      sortable: true,
      width: "180px",
    },
    {
      name: "Email",
      selector: (data) => data.email.toLowerCase(),
      cell: (data) => String(data.email),
      sortable: true,
    },
    {
      name: "Business type",
      selector: (data) => data.businessType,
      cell: (data) => String(data.businessType),
      sortable: true,
      width: "150px",
    },
    {
      name: "Total event buyers",
      selector: (data) => parseInt(data.totalEventBuyers, 10),
      width: "180px",
      cell: (data) => String(data.totalEventBuyers),
      sortable: true,
    },
    {
      name: "Total event items",
      selector: (data) => parseInt(data.totalEventItems, 10),
      width: "150px",
      cell: (data) => String(data.totalEventItems),
      sortable: true,
    },
    {
      name: "Total events",
      selector: (data) => parseInt(data.totalEvents, 10),
      width: "150px",
      cell: (data) => String(data.totalEvents),
      sortable: true,
    },
    {
      name: "Total participants",
      selector: (data) => parseInt(data.totalParticipants, 10),
      width: "180px",
      cell: (data) => String(data.totalParticipants),
      sortable: true,
    },
    {
      name: "Status",
      selector: (data) => data.status,
      width: "150px",
      cell: (data) => String(data.status),
      sortable: true,
    },
    {
      name: "Auction create rights",
      selector: (data) => data.auctionStatus,
      width: "180px",
      cell: (data) => String(data.auctionStatus),
      sortable: true,
    },
    {
      name: "Action",
      width: "150px",
      sortable: false,
      cell: (data) => (
        <div>
          <Button
            aria-describedby={id}
            variant="contained"
            onClick={(event) =>
              handleClick(event, data.userId, data.status, data.auctionStatus)
            }
          >
            <MoreVertIcon />
          </Button>
          <Popover
            id={id}
            open={open}
            anchorEl={anchorEl}
            onClose={handleClose}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "left",
            }}
          >
            <Typography sx={{ p: 2, display: "grid" }}>
              <div
                className={classes.viewBtn}
                onClick={() => {
                  SetChangeView("AuctionTable");
                  SetBuyerId(buyerId);
                }}
              >
                <RemoveRedEyeIcon
                  style={{ color: "#2D55EB", paddingRight: "5px" }}
                />
                Report
              </div>
              <span className={classes.viewBtn} onClick={handleOpen}>
                <EditIcon style={{ color: "#2D55EB", paddingRight: "5px" }} />
                Edit
              </span>
              <span
                className={classes.viewBtn}
                onClick={() => handleClickOpen(buyerId)}
              >
                <DeleteIcon style={{ color: "red", paddingRight: "5px" }} />
                Delete
              </span>
              {status === "ACTIVE" ? (
                <span
                  className={classes.viewBtn}
                  onClick={() => handleClickStatusOpen(buyerId, status)}
                >
                  <CancelIcon style={{ color: "red", paddingRight: "5px" }} />
                  Inactive
                </span>
              ) : (
                <span
                  className={classes.viewBtn}
                  onClick={() => handleClickStatusOpen(buyerId, status)}
                >
                  <CheckIcon style={{ color: "green", paddingRight: "5px" }} />
                  Active
                </span>
              )}

              <span
                className={classes.viewBtn}
                onClick={() =>
                  handleClickRightsOpen(sellerRightsId, auctionRights)
                }
              >
                <EditIcon style={{ color: "#2D55EB", paddingRight: "5px" }} />
                Auction Rights
              </span>
            </Typography>
          </Popover>
        </div>
      ),
    },
  ];

  const [openDilogue, setOpenDilogue] = React.useState(false);
  const [deleteSellerId, setDeleteSellerId] = React.useState("");

  const updateDeleteSeller = async () => {
    try {
      await sellerDeleteAPI(deleteSellerId);
      toast("Seller Deleted Successfully!");
      setTimeout(() => {
        sellerList();
        setOpenDilogue(false);
        setAnchorEl(null);
      }, 1000);
    } catch (error) {
      console.log(error);
    }
  };

  const handleClickOpen = (eventId) => {
    setOpenDilogue(true);
    setDeleteSellerId(eventId);
  };

  const handleCloseDilogue = () => {
    setOpenDilogue(false);
    setAnchorEl(null);
  };

  const [openStatusDilogue, setOpenStatusDilogue] = React.useState(false);
  const [openRightsDilogue, setOpenRightsDilogue] = React.useState(false);

  const handleClickStatusOpen = (eventId, status) => {
    setOpenStatusDilogue(true);
    setstatusSellerId(eventId);
    setStatusSeller(status);
  };

  const handleClickRightsOpen = (sellerRightsId, auctionStatus) => {
    setOpenRightsDilogue(true);
    setSellerRightsId(sellerRightsId);
    console.log("setSellerRightsId", sellerRightsId);
    setSellerRights(auctionStatus);
  };

  const handleCloseStatusDilogue = () => {
    setOpenStatusDilogue(false);
    setAnchorEl(null);
  };

  const handleCloseRightsDilogue = () => {
    setOpenRightsDilogue(false);
    setAnchorEl(null);
  };

  const [statusSellerId, setstatusSellerId] = React.useState("");
  const [sellerRightsId, setSellerRightsId] = React.useState("");
  const [statusSeller, setStatusSeller] = React.useState("");
  const [sellerRights, setSellerRights] = React.useState("");

  const updateStatusSeller = async () => {
    try {
      let statusFlag = "ACTIVE";
      if (statusSeller === "ACTIVE") {
        statusFlag = "INACTIVE";
      }
      const payload1 = { status: statusFlag };

      await sellerStatusUpdateAPI(payload1, statusSellerId);
      console.clear();
      toast("Seller Status Updated!");
      setTimeout(() => {
        sellerList();
        setOpenStatusDilogue(false);
        setAnchorEl(null);
      }, 1000);
    } catch (error) {
      console.log(error);
    }
  };

  const updateRightsSeller = async () => {
    try {
      const auctionRights = {};
      if (sellerRights === "YES") {
        auctionRights.auctionStatus = "NO";
      } else {
        auctionRights.auctionStatus = "YES";
      }

      await sellerUpdateRightsAPI(auctionRights, sellerRightsId);

      toast("Seller Rights Updated!");
      setTimeout(() => {
        sellerList();
        setOpenRightsDilogue(false);
        setAnchorEl(null);
      }, 1000);
    } catch (error) {
      toast(error.message);
      setOpenRightsDilogue(false);
      setAnchorEl(null);
    }
  };

  // FIX 3: Reset editProfile when modal opens/closes
  const [modalOpen, setModalOpen] = useState({});
  const [editProfile, setEditProfile] = useState(false);

  const handleOpen = (text) => {
    // Clear any existing form data first
    setUserInfoSeller({
      firstName: "",
      lastName: "",
      email: "",
      contactNumber: "",
      alternateContactNumber: "",
      bi_tin_ein: "",
      businessType: "",
      companyName: "",
      city: "",
      country: "",
      postalCode: "",
      state: "",
      streetOne: "",
      streetTwo: "",
      title: "",
      auctionGracePeriodHours: "",
    });

    setEditProfile(false); // Reset edit mode when opening modal
    setErrors({}); // Clear any validation errors

    setModalOpen({
      visible: true,
      type: text,
    });

    // Refresh profile data when opening modal to ensure latest values
    if (sellerId) {
      getProfileData(sellerId);
    }
  };

  const handleCloseModal = (text) => {
    setEditProfile(false); // Reset edit mode when closing modal
    setModalOpen({
      visible: false,
      type: text,
    });
    // Clear form data when closing modal
    setUserInfoSeller({
      firstName: "",
      lastName: "",
      email: "",
      contactNumber: "",
      alternateContactNumber: "",
      bi_tin_ein: "",
      businessType: "",
      companyName: "",
      city: "",
      country: "",
      postalCode: "",
      state: "",
      streetOne: "",
      streetTwo: "",
      title: "",
      auctionGracePeriodHours: "", // New field
    });
    setErrors({});
  };

  const userData = getUserData() ?? {};

  const [profileDetail, setProfileDetail] = useState({
    apiState: "loading",
    list: "",
  });

  const getProfileData = async (sellerId) => {
    try {
      const { data } = await getSellerDetails(sellerId);
      if (data) {
        setProfileDetail({ apiState: "success", list: data });
        // FIX 2: Load states when profile data is loaded
        if (data.country) {
          stateData(data.country);
        }
        // Initialize the grace period field with the actual value from database
        if (data.auctionGracePeriodHours !== undefined) {
          setUserInfoSeller((prev) => ({
            ...prev,
            auctionGracePeriodHours: data.auctionGracePeriodHours.toString(),
          }));
        }
      } else {
        throw new Error(data);
      }
    } catch (error) {
      console.clear();
      console.log(error);
    }
  };

  const [passwordType, setPasswordType] = useState("password");
  const [passwordInput, setPasswordInput] = useState("");

  const togglePassword = () => {
    if (passwordType === "password") {
      setPasswordType("text");
      return;
    }
    setPasswordType("password");
  };

  // Validation Form
  const [errors, setErrors] = useState({});

  const validate = (event, name, value) => {
    const re = /^[A-Za-z ]+$/;
    const numberRe = /^\d+$/;

    switch (name) {
      case "firstName":
        if (!re.test(value)) {
          setErrors({
            ...errors,
            firstName: "First Name should contains only Letters",
          });
        } else {
          let newObj = omit(errors, "firstName");
          setErrors(newObj);
        }
        break;

      case "lastName":
        if (!re.test(value)) {
          setErrors({
            ...errors,
            lastName: "Last Name should contains only Letters",
          });
        } else {
          let newObj = omit(errors, "lastName");
          setErrors(newObj);
        }
        break;

      case "email":
        if (
          !new RegExp(
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          ).test(value)
        ) {
          setErrors({
            ...errors,
            email: "Enter a valid email address",
          });
        } else {
          let newObj = omit(errors, "email");
          setErrors(newObj);
        }
        break;

      // FIX 4: Add validation for grace period
      case "auctionGracePeriodHours":
        if (
          value &&
          (!numberRe.test(value) ||
            parseInt(value) < 0 ||
            parseInt(value) > 168)
        ) {
          setErrors({
            ...errors,
            auctionGracePeriodHours:
              "Enter a valid number between 0 and 168 hours (7 days)",
          });
        } else {
          let newObj = omit(errors, "auctionGracePeriodHours");
          setErrors(newObj);
        }
        break;

      default:
        break;
    }
  };

  const [userInfoSeller, setUserInfoSeller] = useState({
    firstName: "",
    lastName: "",
    email: "",
    contactNumber: "",
    alternateContactNumber: "",
    bi_tin_ein: "",
    businessType: "",
    companyName: "",
    city: "",
    country: "",
    postalCode: "",
    state: "",
    streetOne: "",
    streetTwo: "",
    title: "",
    auctionGracePeriodHours: "",
  });

  const handleChangeSeller = (event) => {
    event.persist();
    validate(event, event.target.name, event.target.value);
    if (event.target.name === "country") stateData(event.target.value);
    setUserInfoSeller({
      ...userInfoSeller,
      [event.target.name]: event.target.value,
    });
  };

  const handleSubmitSeller = async (event) => {
    try {
      event.preventDefault();

      if (!isEmpty(errors)) {
        toast("Please fill correct value on all fields. !");
      } else {
        // Create payload with fallback values
        const payload = {
          firstName: userInfoSeller.firstName || profileDetail.list.firstName,
          lastName: userInfoSeller.lastName || profileDetail.list.lastName,
          alternateContactNumber:
            userInfoSeller.alternateContactNumber ||
            profileDetail.list.alternateContactNumber,
          contactNumber:
            userInfoSeller.contactNumber || profileDetail.list.contactNumber,
          email: userInfoSeller.email || profileDetail.list.email,
          companyName:
            userInfoSeller.companyName || profileDetail.list.companyName,
          bi_tin_ein:
            userInfoSeller.bi_tin_ein || profileDetail.list.bi_tin_ein,
          businessType:
            userInfoSeller.businessType || profileDetail.list.businessType,
          city: userInfoSeller.city || profileDetail.list.city,
          country: userInfoSeller.country || profileDetail.list.country,
          postalCode:
            userInfoSeller.postalCode || profileDetail.list.postalCode,
          state: userInfoSeller.state || profileDetail.list.state,
          streetOne: userInfoSeller.streetOne || profileDetail.list.streetOne,
          streetTwo: userInfoSeller.streetTwo || profileDetail.list.streetTwo,
          title: userInfoSeller.title || profileDetail.list.title,
          auctionGracePeriodHours:
            userInfoSeller.auctionGracePeriodHours !== undefined &&
            userInfoSeller.auctionGracePeriodHours !== ""
              ? userInfoSeller.auctionGracePeriodHours
              : profileDetail.list.auctionGracePeriodHours !== undefined
              ? profileDetail.list.auctionGracePeriodHours
              : "72",
        };

        const { data } = await updateSellerAPI(payload, sellerId);

        if (data) {
          toast("Profile Updated Successfully. !");
          sellerList();
          setOpenDilogue(false);
          setAnchorEl(null);
          setModalOpen({
            visible: false,
          });
          setUserInfoSeller({
            firstName: "",
            lastName: "",
            email: "",
            contactNumber: "",
            alternateContactNumber: "",
            bi_tin_ein: "",
            businessType: "",
            companyName: "",
            city: "",
            country: "",
            postalCode: "",
            state: "",
            streetOne: "",
            streetTwo: "",
            title: "",
            auctionGracePeriodHours: "",
          });
        }
      }
    } catch (error) {
      toast(error.response?.data?.error || "An error occurred");
      setIsLoading(false);
      if (error.response?.status === 500) {
        toast("Network error!");
        setIsLoading(false);
      } else if (error.request) {
        toast("Something went wrong!");
        setIsLoading(false);
      } else {
        console.log("Error", error.message);
        setIsLoading(false);
      }
    }
  };

  const exportToXLSX = (tableData, tableHeader) => {
    const headerColumns = lodash
      .map(tableHeader, ({ name }) => {
        if (name !== "Action") {
          return name;
        }
      })
      .filter(Boolean);

    const dataColumns = lodash.map(tableData, (columns) => [
      columns.id,
      columns.title,
      columns.userName,
      columns.companyName,
      columns.contactNumber,
      columns.alternateContactNumber,
      columns.email,
      columns.businessType,
      parseFloat(Number(columns.totalEventBuyers)),
      parseFloat(Number(columns.totalEventItems)),
      parseFloat(Number(columns.totalEvents)),
      parseInt(Number(columns.totalParticipants)),
      columns.status,
      columns.auctionStatus,
    ]);

    const workbook = XLSX.utils.book_new();
    const worksheet = XLSX.utils.aoa_to_sheet([headerColumns, ...dataColumns]);

    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
    XLSX.writeFile(workbook, "sellers-list.xlsx");
  };

  const ExportButton = () => (
    <Button onClick={() => exportToXLSX(tableSellers, columns)}>
      <FaRegFileExcel
        style={{ fontSize: "30px", color: "#04aa18", paddingTop: "4px" }}
      />
    </Button>
  );

  const renderComponent = () => {
    switch (changeView) {
      case "AuctionView":
        return (
          <AuctionView
            Bidlog={() => {
              SetChangeView("AuctionBid");
            }}
            BidlogSecond={(eventItemId) => {
              SetChangeView("BidlogSecond");
              SetEvenItemtId(eventItemId);
            }}
            AuctionTable={() => {
              SetChangeView("AuctionTable");
            }}
            eventId={eventId}
          />
        );
      case "AuctionBid":
        return (
          <BidlogFirst
            DashBuyerDetail={(buyerId) => {
              SetChangeView("DashBuyerDetail");
              SetBuyerId(buyerId);
            }}
            AuctionView={() => {
              SetChangeView("AuctionView");
            }}
            eventId={eventId}
            AuctionViewFirst={() => {
              SetChangeView("AuctionViewFirst");
            }}
            AuctionSummary={() => {
              SetChangeView("AuctionSummary");
            }}
          />
        );
      case "BidlogSecond":
        return (
          <BidlogSecond
            AuctionView={() => {
              SetChangeView("AuctionView");
            }}
            eventItemId={eventItemId}
            eventId={eventId}
          />
        );
      case "DashBuyerDetail":
        return (
          <DashBuyerDetail
            DashEventDetail={(buyerId, buyerEventId) => {
              SetChangeView("DashEventDetail");
              SetBuyerEventId(buyerEventId);
            }}
            BidlogFirst={() => {
              SetChangeView("AuctionBid");
            }}
            buyerId={buyerId}
          />
        );

      case "DashEventDetail":
        return (
          <DashEventDetail
            BuyerBidLog={(eventItemId) => {
              SetChangeView("BuyerBidLog");
              SetBuyerEvenItemtId(eventItemId);
            }}
            DashBuyerDetail={(buyerId) => {
              SetChangeView("DashBuyerDetail");
              SetBuyerId(buyerId);
            }}
            buyerId={buyerId}
            buyerEventId={buyerEventId}
          />
        );
      case "BuyerBidLog":
        return (
          <BuyerBidLog
            DashEventDetail={() => {
              SetChangeView("DashEventDetail");
            }}
            buyerId={buyerId}
            buyerEventId={buyerEventId}
            buyerEventItemId={buyerEventItemId}
          />
        );
      case "EditTabEvent":
        return <EditTabEvent />;

      case "EditEvent":
        return (
          <EditEvent
            AuctionTable={() => {
              SetChangeView("AuctionTable");
            }}
            EditTabEvent={() => {
              SetChangeView("EditTabEvent");
            }}
          />
        );
      case "AuctionTable":
        return (
          <AuctionTable
            onView={(eventId) => {
              SetChangeView("AuctionView");
              SetEventId(eventId);
            }}
            onEdit={() => {
              SetChangeView("EditEvent");
            }}
            buyerId={buyerId}
          />
        );
      case "AuctionViewFirst":
        return (
          <AuctionViewFirst
            BidlogFirst={() => {
              SetChangeView("AuctionBid");
            }}
          />
        );
      case "AuctionSummary":
        return (
          <AuctionSummary
            BidlogFirst={() => {
              SetChangeView("AuctionBid");
            }}
          />
        );
      default:
        return (
          <div className="AuctionTable">
            {userData.role !== "SELLER" && userData.role !== "BUYER" ? (
              <>
                <h3>Seller List</h3>
                <DataTableExtensions
                  print={false}
                  export={false}
                  exportHeaders={false}
                  columns={columns}
                  data={tableSellers}
                >
                  <DataTable
                    noHeader={false}
                    defaultSortField="id"
                    defaultSortAsc={false}
                    pagination
                    highlightOnHover
                    className="DataTable"
                    actions={<ExportButton />}
                  />
                </DataTableExtensions>
              </>
            ) : (
              <Navigate to={{ pathname: "/dashboard" }} />
            )}

            {/* Dialog box for delete seller */}
            <Dialog
              open={openDilogue}
              onClose={handleCloseDilogue}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <DialogTitle id="alert-dialog-title">
                {"Delete Seller ?"}
              </DialogTitle>
              <DialogContent>
                <DialogContentText id="alert-dialog-description">
                  Are you sure you want to delete Seller ?
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button onClick={handleCloseDilogue}>Cancel</Button>
                <Button onClick={updateDeleteSeller} autoFocus>
                  Delete
                </Button>
              </DialogActions>
            </Dialog>

            {/* dialog box for status change */}
            <Dialog
              open={openStatusDilogue}
              onClose={handleCloseStatusDilogue}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <DialogTitle id="alert-dialog-title">
                {"Status Seller ?"}
              </DialogTitle>
              <DialogContent>
                <DialogContentText id="alert-dialog-description">
                  Are you sure you want to change status of Seller ?
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button onClick={handleCloseStatusDilogue}>Cancel</Button>
                <Button onClick={updateStatusSeller} autoFocus>
                  Update
                </Button>
              </DialogActions>
            </Dialog>

            {/* dialog box for auction rights change */}
            <Dialog
              open={openRightsDilogue}
              onClose={handleCloseRightsDilogue}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <DialogTitle id="alert-dialog-title">
                {"Change Auction Rights ?"}
              </DialogTitle>
              <DialogContent>
                <DialogContentText id="alert-dialog-description">
                  Are you sure you want to change user rights of Seller ?
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button onClick={updateRightsSeller}>Yes</Button>
                <Button onClick={handleCloseRightsDilogue} autoFocus>
                  No
                </Button>
              </DialogActions>
            </Dialog>

            <SellerProfileModal
              open={modalOpen.visible}
              handleClose={handleCloseModal}
              profileDetail={profileDetail.list}
              handleChangeSeller={handleChangeSeller}
              handleSubmitSeller={handleSubmitSeller}
              userInfoSeller={userInfoSeller}
              errors={errors}
              editProfile={editProfile}
              setEditProfile={setEditProfile}
              setErrors={setErrors}
              passwordType={passwordType}
              togglePassword={togglePassword}
              setPasswordInput={setPasswordInput}
              passwordInput={passwordInput}
              countriesList={countriesList.list}
              stateList={stateList.list}
              companyName={
                userInfoSeller.companyName || profileDetail.list.companyName
              }
              businessType={
                userInfoSeller.businessType || profileDetail.list.businessType
              }
              bi_tin_ein={
                userInfoSeller.bi_tin_ein || profileDetail.list.bi_tin_ein
              }
              streetOne={
                userInfoSeller.streetOne || profileDetail.list.streetOne
              }
              streetTwo={
                userInfoSeller.streetTwo || profileDetail.list.streetTwo
              }
              city={userInfoSeller.city || profileDetail.list.city}
              country={userInfoSeller.country || profileDetail.list.country}
              postalCode={
                userInfoSeller.postalCode || profileDetail.list.postalCode
              }
              state={userInfoSeller.state || profileDetail.list.state}
              firstName={
                userInfoSeller.firstName || profileDetail.list.firstName
              }
              lastName={userInfoSeller.lastName || profileDetail.list.lastName}
              email={userInfoSeller.email || profileDetail.list.email}
              title={userInfoSeller.title || profileDetail.list.title}
              contactNumber={
                userInfoSeller.contactNumber || profileDetail.list.contactNumber
              }
              alternateContactNumber={
                userInfoSeller.alternateContactNumber ||
                profileDetail.list.alternateContactNumber
              }
              auctionGracePeriodHours={
                userInfoSeller.auctionGracePeriodHours !== undefined &&
                userInfoSeller.auctionGracePeriodHours !== ""
                  ? userInfoSeller.auctionGracePeriodHours
                  : profileDetail.list.auctionGracePeriodHours !== undefined
                  ? profileDetail.list.auctionGracePeriodHours.toString()
                  : "72"
              }
            />
          </div>
        );
    }
  };
  return (
    <div className={classes.section}>
      <div className="container">
        <div className={classes.Dashboard}>
          <div className={classes.dashboardCard}>
            <DashboardMenu />
            <div className={classes.dashboardCards}>{renderComponent()}</div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default DashSeller;
